<template>
    <div class="objectivePanel">
        <div class="opTitle">{{ $t('stockPage.objectives.title') }}</div>
        <div class="objectives">
            <v-combobox
                v-model="selectedObjective"
                :items="objectives"
                :label="$t('stockPage.objectives.selectObjective')"
                item-text="name"
                item-value="id"
                outlined
                dense
                class="objList"
                hide-details="auto"
                @change="dirty=true"></v-combobox>
            <v-text-field
                v-model="amount"
                :label=amountPlaceholder
                outlined
                dense
                class="objNumber"
                hide-details="auto"
                :disabled="selectedObjective === null"
                @input="dirty=true"></v-text-field>
            <div class="actions">
                <v-btn
                    fab
                    small
                    :dark="saveBtnEnabled"
                    :disabled="!saveBtnEnabled"
                    color="primary"
                    @click="save"
                >
                    <font-awesome-icon :icon="icons.save" class="fa-fw fa-lg"></font-awesome-icon>
                </v-btn>
                <v-btn
                    v-if="dirty"
                    fab
                    small
                    :dark="dirty"
                    :disabled="!dirty"
                    color="secondary"
                    @click="cancel"
                >
                    <font-awesome-icon :icon="icons.cancel" class="fa-fw fa-lg"></font-awesome-icon>
                </v-btn>
                <v-btn
                    v-else
                    fab
                    small
                    :dark="deleteBtnEnabled"
                    :disabled="!deleteBtnEnabled"
                    color="red"
                    @click="deleteObjective"
                >
                    <font-awesome-icon :icon="icons.delete" class="fa-fw fa-lg"></font-awesome-icon>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { faCheck, faTrashAlt, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { addOrUpdateObjective, deleteObjective } from '../../services/PortfolioService';
import StockMixin from '../stocks/StockMixin';

export default {
    mixins: [StockMixin],
    data() {
        return {
            icons: {
                save: faCheck,
                cancel: faTimes,
                delete: faTrashAlt
            },
            selectedObjective: null,
            dirty: false,
            amount: null,
            objectives: [
                { id: 'totalTargetedValue', name: this.$t('stockPage.objectives.totalTargetedValue.label') },
                { id: 'totalInvestmentTargetedAmount', name: this.$t('stockPage.objectives.totalInvestmentTargetedAmount.label') },
                { id: 'totalTargetedShareCount', name: this.$t('stockPage.objectives.totalTargetedShareCount.label') },
                { id: 'percentageOfTotalInvestmentValue', name: this.$t('stockPage.objectives.percentageOfTotalInvestmentValue.label') }
            ]
        }
    },
    mounted() {
        this.load(this.stockObjective);
    },
    computed: {
        saveBtnEnabled() {
            return this.dirty && (this.selectedObjective !== null && this.amount !== null);
        },
        deleteBtnEnabled() {
            return this.selectedObjective !== null;
        },
        stockObjective() {
            return this.$store.getters.stockObjectives.find(so => so.stockId === this.stockId);
        },
        amountPlaceholder() {
            return this.selectedObjective ? this.$t(`stockPage.objectives.${this.selectedObjective.id}.placeholder`) : '';
        }
    },
    methods: {
        load(stockObjective) {
            if (stockObjective) {
                this.selectedObjective = this.objectives.find(o => o.id === stockObjective.primaryObjective);
                this.amount = stockObjective.primaryObjectiveValue;
            }
            this.dirty = false;
        },
        save() {
            const stockId = this.$store.getters.completeStockInfo.stockId;
            const primaryObjective = this.selectedObjective.id;
            const stockObjectiveDetails = {}
            stockObjectiveDetails[primaryObjective] = this.amount;
            addOrUpdateObjective({ stockId, primaryObjective, stockObjectiveDetails }).then(() => {
                this.fetchUserListData().catch(error => {
                    console.error('Error fetching user list data', error);
                })
                .finally(() => {
                    this.dirty = false;
                });
            }).catch(error => {
                console.error('Error saving objective', error);
            });
        },
        cancel() {
            this.load(this.$store.getters.stockObjectives.find(so => so.stockId === this.stockId));
            this.dirty = false;
        },
        deleteObjective() {
            deleteObjective({ stockId: this.$store.getters.completeStockInfo.stockId })
            .then(() => {
                this.selectedObjective = null;
                this.amount = null;
                this.dirty = false;
            })
            .catch(error => {
                console.error('Error deleting objective', error);
            });
        }
    },
    watch: {
        stockObjective(val) {
            if (val) {
                this.load(val);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.objectivePanel {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: var(--v-lightGrayBG-base);
    padding: 20px;
    .opTitle {
        font-size: 1.1em;
        font-weight: bold;
    }
    .objectives {
        display: flex;
        gap: 20px;
        z-index: 10;
        background-color: #FFF;
        padding: 15px;
        .actions {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }
    @media screen and (max-width: $small) {
        padding: 10px;
        .objectives {
            padding: 15px 10px;
            .objList{
                flex: 2;
            }
            .objNumber{
                flex: 1;
            }
        }
    }
}
</style>